import { Box } from '@factorialco/deprecated-design-system'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import DescriptionField from './DescriptionField'
import InternalReferenceField from './InternalReferenceField'

interface Props extends PermissionsProps, CustomizationProps {}

const AdditionalInformation = (props: Props) => {
  return (
    <Box gap="s24">
      <DescriptionField {...props} fieldIdentifier="description" />
      <InternalReferenceField {...props} fieldIdentifier="internal_reference" />
    </Box>
  )
}

export default AdditionalInformation
